import React from "react";
import UserWrapper from "../Store/user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import AdminTable from "./AdminTable";

const AdminManagement = props => {
  return (
    <UserWrapper {...props}>
      <PageTitle
        title="sidebar.adminManagement"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard"
          },
          {
            name: "sidebar.adminManagement"
          },
          {
            name: "sidebar.lists"
          }
        ]}
      />
      <div className="user-tbl">
        <AdminTable {...props} />
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(AdminManagement);

